/* @ngInject */

export default (helperService, helperPdfService) => {
  /**
   * Prepare asset finance supporting commentary details.
   *
   * @param {Object} loan
   *
   * @returns {Object}
   */
  const prepareAssetFinanceSupportingCommentaryDetails = ({ loan }) => {
    const content = [];
    content.push({
      table: {
        widths: ['*'],
        body: [
          [
            {
              text: [
                {
                  text: 'Background/purpose\n',
                  style: 'label'
                },
                {
                  text:
                    loan?.compliance?.comments?.analysisAssessmentAndApplicantEducation || '-',
                  style: 'value'
                }
              ]
            }
          ],
          [
            {
              text: [
                {
                  text: 'Credit history\n',
                  style: 'label'
                },
                {
                  text: loan?.compliance?.comments?.creditHistory || '-',
                  style: 'value'
                }
              ]
            }
          ],
          [
            {
              text: [
                {
                  text: 'General notes\n',
                  style: 'label'
                },
                {
                  text: loan?.compliance?.comments?.general || '-',
                  style: 'value'
                }
              ]
            }
          ]
        ]
      },
      layout: 'noBorders'
    });
    return content;
  };

  /**
   * Prepare home loan supporting commentary details for Australia.
   *
   * @param {Object} loan
   *
   * @returns {Object}
   */
  const prepareHomeLoanSupportingCommentaryDetailsAU = ({ loan }) => {
    const content = [];
    content.push({
      table: {
        widths: ['*'],
        body: [
          [
            {
              text: [
                {
                  text: 'Borrowing power commentary\n',
                  style: 'label'
                },
                {
                  text: loan?.compliance?.comments?.borrowingPower || '-',
                  style: 'value'
                }
              ]
            }
          ],
          [
            {
              text: [
                {
                  text: 'Deposit/Equity comments\n',
                  style: 'label'
                },
                {
                  text: loan?.compliance?.comments?.depositOrEquity || '-',
                  style: 'value'
                }
              ]
            }
          ],
          [
            {
              text: [
                {
                  text: 'Credit history comments\n',
                  style: 'label'
                },
                {
                  text: loan?.compliance?.comments?.creditHistory || '-',
                  style: 'value'
                }
              ]
            }
          ],
          [
            {
              text: [
                {
                  text: 'Security (property) notes\n',
                  style: 'label'
                },
                {
                  text: loan?.compliance?.comments?.security || '-',
                  style: 'value'
                }
              ]
            }
          ],
          [
            {
              text: [
                {
                  text: 'Application submission notes\n',
                  style: 'label'
                },
                {
                  text: loan?.compliance?.comments?.applicationSubmission || '-',
                  style: 'value'
                }
              ]
            }
          ],
          [
            {
              text: [
                {
                  text: 'Living expenses comments\n',
                  style: 'label'
                },
                {
                  text: loan?.compliance?.comments?.livingExpenses || '-',
                  style: 'value'
                }
              ]
            }
          ]
        ]
      },
      layout: 'noBorders'
    });
    return content;
  };

  /**
   * Prepare home loan supporting commentary details for New Zealand.
   *
   * @param {Object} loan
   *
   * @returns {Object}
   */
  const prepareHomeLoanSupportingCommentaryDetailsNZ = ({ loan }) => {
    const content = [];
    content.push({
      table: {
        widths: ['*'],
        body: [
          [
            {
              text: [
                {
                  text: 'Deposit/Equity comments\n',
                  style: 'label'
                },
                {
                  text: loan?.compliance?.comments?.depositOrEquity || '-',
                  style: 'value'
                }
              ]
            }
          ],
          [
            {
              text: [
                {
                  text: 'Credit history comments\n',
                  style: 'label'
                },
                {
                  text: loan?.compliance?.comments?.creditHistory || '-',
                  style: 'value'
                }
              ]
            }
          ],
          [
            {
              text: [
                {
                  text: 'Security (property) notes\n',
                  style: 'label'
                },
                {
                  text: loan?.compliance?.comments?.security || '-',
                  style: 'value'
                }
              ]
            }
          ],
          [
            {
              text: [
                {
                  text: 'Borrowing power commentary\n',
                  style: 'label'
                },
                {
                  text: loan?.compliance?.comments?.borrowingPower || '-',
                  style: 'value'
                }
              ]
            }
          ],
          [
            {
              text: [
                {
                  text: 'Living expenses comments\n',
                  style: 'label'
                },
                {
                  text: loan?.compliance?.comments?.livingExpenses || '-',
                  style: 'value'
                }
              ]
            }
          ],
          [
            {
              text: [
                {
                  text: 'Application submission notes\n',
                  style: 'label'
                },
                {
                  text: loan?.compliance?.comments?.applicationSubmission || '-',
                  style: 'value'
                }
              ]
            }
          ]
        ]
      },
      layout: 'noBorders'
    });
    return content;
  };

  /**
   * Prepare supporting commentary details.
   *
   * @param {String} title
   * @param {String} pageBreak
   *
   * @returns {Object}
   */
  const prepareSupportingCommentaryDetails = ({ loan, workflow }) => {
    const content = [];
    if (loan) {
      content.push(
        helperPdfService.createHeader({
          title: 'SUPPORTING COMMENTARY',
          pageBreak: 'before'
        })
      );
      if (workflow?.isAssetFinance()) {
        content.push(prepareAssetFinanceSupportingCommentaryDetails({ loan }));
      }
      if (workflow?.isHomeLoan() && helperService.getOrganizationCountry().cca2 === 'AU') {
        content.push(prepareHomeLoanSupportingCommentaryDetailsAU({ loan }));
      }
      if (workflow?.isHomeLoan() && helperService.getOrganizationCountry().cca2 === 'NZ') {
        content.push(prepareHomeLoanSupportingCommentaryDetailsNZ({ loan }));
      }
    }
    return content;
  };

  return {
    prepareSupportingCommentaryDetails
  };
};
